import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import { BaseButtons, TextInputField } from "../../../common-components";
import ImageUploadAWS from "../../../user/components/image-upload/ImageUploadAWS";
import SearchBar from "../../../common-components/search-bar/SearchBar";
import { BranchCard } from "./components";

const ManagerDisplay = ({
  setLoading,
  setPopUpTitle,
  setToastPop,
  setMessage,
  setRefresh,
  refresh,
  getUserInvites,
  auth,
  invitesArray,
  width,
  branchDisplay,
  setBranchDisplay,
  //   isMainAdmin,
}) => {
  const [orgName, setOrgName] = useState("");
  const [orgId, setOrgId] = useState("");
  const [orgEmail, setOrgEmail] = useState("");
  const [address, setAddress] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [idNumber, setIdNumber] = useState("");
  const [driverLiscense, setDriverLiscense] = useState("");
  const [driverLiscenseImage, setDriverLiscenseImage] = useState("");
  const [imageError, setImageError] = useState("");

  const [isMainAdmin, setIsMainAdmin] = useState(false);

  const handleFileChangeDriverLiscense = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setDriverLiscense(file);
  };
  //   useEffect(() => {
  //     getUserInvites();
  //   }, [tableDisplay, refresh]);
  return (
    <div
      style={{
        height: "88%",
        maxHeight: 900,
        minHeight: 450,
        width: width > 899 ? "94%" : "100%",
        minWidth: width > 899 ? 500 : null,
        maxWidth: 1500,
        // backgroundColor: colors.secondaryGrey,
        marginTop: width > 899 ? 20 : 0,
        borderRadius: 20,
        marginLeft: width > 899 ? 5 : 0,
        // WebkitBoxShadow: "-2px 20px 40px -10px #000000",

        borderWidth: 4,
        // borderColor: colors.white,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        // overflow: "hidden",
        position: "relative",
      }}
    >
      {isMainAdmin ? (
        width > 899 ? (
          <>
            <div
              style={{
                height: "100%",
                maxHeight: 900,
                minHeight: 450,
                width: "50%",
                minWidth: 500,
                maxWidth: 1500,
                backgroundColor: colors.secondaryGrey,
                //   marginTop: 20,
                borderRadius: 20,
                marginLeft: 5,
                WebkitBoxShadow: "-2px 20px 40px -10px #000000",
                borderStyle: "solid",
                borderWidth: 4,
                borderColor: colors.white,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "hidden",
                position: "relative",
                flexDirection: "column",
              }}
            >
              <div style={{ position: "absolute", right: 10, top: 10 }}>
                <BaseButtons
                  label={"UPDATE"}
                  borderRadius={8}
                  backgroundColor={colors.primaryOrange}
                  width={120}
                />
              </div>
              <div style={{ position: "absolute", left: 10, top: 10 }}>
                <BaseButtons
                  label={"IS BRANCH"}
                  borderRadius={8}
                  backgroundColor={colors.primaryOrange}
                  width={120}
                  onClick={() => setIsMainAdmin(false)}
                />
              </div>
              <div style={{ display: "flex", position: "relative" }}>
                <div
                  style={{
                    height: 150,
                    minWidth: 150,
                    // borderStyle: "solid",
                    borderRadius: 8,
                    marginBottom: 5,
                    marginTop: 5,
                    backgroundColor: colors.white,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    //   position: "absolute",
                    //   top: -200,
                  }}
                >
                  Image display
                </div>
                <div style={{ width: 40 }} />
                <ImageUploadAWS
                  onChange={(e) => handleFileChangeDriverLiscense(e)}
                  labelTitle={"UPLOAD COMPANY LOGO"}
                  mini={true}
                  errorDisplay={imageError}
                  width={"100%"}
                  size={120}
                  height={30}
                />
              </div>

              <TextInputField
                width={"80%"}
                size={"83%"}
                labelTitle={"ORGNAISATION NAME"}
                mini={true}
                value={orgName}
                onChange={(e) => setOrgName(e.target.value)}
              />

              <TextInputField
                width={"80%"}
                size={"83%"}
                labelTitle={"Organisation Id"}
                mini={true}
                value={orgId}
                onChange={(e) => setOrgId(e.target.value)}
              />
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <TextInputField
                  width={"40%"}
                  size={"65%"}
                  labelTitle={"Organisation email"}
                  mini={true}
                  value={orgEmail}
                  onChange={(e) => setOrgEmail(e.target.value)}
                />
                <TextInputField
                  width={"40%"}
                  size={"65%"}
                  labelTitle={"CONTACT INFO"}
                  mini={true}
                  value={orgEmail}
                  onChange={(e) => setOrgEmail(e.target.value)}
                />
              </div>

              <TextInputField
                width={"80%"}
                size={"83%"}
                labelTitle={"CIPRO Registration"}
                mini={true}
                value={orgEmail}
                onChange={(e) => setOrgEmail(e.target.value)}
              />
              <TextInputField
                width={"80%"}
                size={"83%"}
                labelTitle={"Address"}
                mini={true}
                value={orgEmail}
                onChange={(e) => setOrgEmail(e.target.value)}
              />

              {/* <div style={{ height: 20 }} />
            <BaseButtons
              label={"ADMIN USER"}
              backgroundColor={colors.orangeDark}
              width={350}
              borderRadius={8}
            /> */}
            </div>
            <div
              style={{
                height: "100%",
                maxHeight: 900,
                minHeight: 450,
                width: "45%",
                minWidth: 300,
                maxWidth: 1500,
                backgroundColor: colors.secondaryGrey,
                //   marginTop: 20,
                borderRadius: 20,
                marginLeft: 5,
                WebkitBoxShadow: "-2px 20px 40px -10px #000000",
                borderStyle: "solid",
                borderWidth: 4,
                borderColor: colors.white,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                overflow: "hidden",
                position: "relative",
                marginLeft: 40,
                flexDirection: "column",
              }}
            >
              <div style={{ position: "absolute", top: 10, right: 10 }}>
                {" "}
                <BaseButtons
                  label={"+ NEW BRANCH"}
                  borderRadius={8}
                  backgroundColor={colors.primaryOrange}
                  width={118}
                  height={40}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  height: 60,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    marginLeft: 15,
                    fontWeight: "bold",
                    fontSize: 22,
                    backgroundColor: colors.secondaryOrange,
                    color: colors.white,
                    padding: 5,
                    borderRadius: 8,
                    width: 200,
                  }}
                >
                  <div style={{ marginLeft: 10 }}>BRANCHES</div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <div style={{ width: 15 }} />
                <SearchBar />
                <div style={{ flex: 1 }} />
                <BaseButtons
                  label={"SEARCH"}
                  borderRadius={4}
                  backgroundColor={colors.orangeDark}
                  width={118}
                  height={35}
                />
                <div style={{ width: 10 }} />
              </div>
              <div
                style={{
                  flex: 1,
                  borderStyle: "solid",
                  width: "95%",
                  marginTop: 10,
                  borderRadius: 20,
                  marginBottom: 10,
                  backgroundColor: colors.white,
                  overflowY: "scroll",
                  overflowX: "hidden",
                  scrollbarWidth: "none",
                  borderColor: colors.white,
                }}
              >
                <BranchCard branchName={"TEST"} />
                <BranchCard branchName={"TEST"} />
                <BranchCard branchName={"TEST"} />
                <BranchCard branchName={"TEST"} />
                <BranchCard branchName={"TEST"} />
                <BranchCard branchName={"TEST"} />
              </div>
            </div>
          </>
        ) : (
          <div
            style={{
              height: "100%",
              width: "100%",
              //   borderStyle: "solid",
              display: "flex",
              flexDirection: "column",
              //   overflowX: "hidden",
              //   overflowY: "scroll",
              position: "relative",
            }}
          >
            {/* tabs display */}
            <div
              style={{
                width: "100%",
                // backgroundColor: colors.white,
                height: 40,
                display: "flex",
                justifyContent: "space-evenly",
                alignItems: "center",
                fontSize: 14,
                position: "absolute",
                top: -0,
                zIndex: 3,
              }}
            >
              <div
                onClick={() => setBranchDisplay("profile")}
                style={{
                  height: "100%",
                  flex: 0.4,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  // borderBottomStyle: "solid",
                  // borderWidth: branchDisplay === "today" ? 3 : 0,
                  // borderColor: colors.greenLight,
                  transition: "all 0.3s",
                  WebkitBoxShadow:
                    branchDisplay === "profile"
                      ? "-5px 5px 15px -1px #00000070"
                      : "0px 0px 0px 0px #00000070",
                  borderBottomRightRadius: branchDisplay === "profile" ? 8 : 4,
                  borderBottomLeftRadius: branchDisplay === "profile" ? 8 : 4,
                  backgroundColor:
                    branchDisplay === "profile"
                      ? colors.primaryOrange
                      : colors.white,
                }}
              >
                <div
                  style={{
                    marginBottom: branchDisplay === "profile" ? 0 : 0,
                    fontWeight: branchDisplay === "profile" ? "bold" : "bold",
                    color:
                      branchDisplay === "profile" ? colors.white : "#00000080",
                    transition: "all 0.3s",
                  }}
                >
                  PROFILE
                </div>
              </div>

              <div
                onClick={() => setBranchDisplay("branches")}
                style={{
                  height: "100%",
                  flex: 0.4,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  // borderBottomStyle: "solid",
                  // borderWidth: branchDisplay === "forYou" ? 3 : 0,
                  // borderColor: colors.greenLight,
                  transition: "all 0.3s",
                  WebkitBoxShadow:
                    branchDisplay === "branches"
                      ? "-5px 5px 15px -1px #00000070"
                      : "0px 0px 0px 0px #00000070",
                  borderBottomRightRadius: branchDisplay === "branches" ? 8 : 4,
                  borderBottomLeftRadius: branchDisplay === "branches" ? 8 : 4,
                  backgroundColor:
                    branchDisplay === "branches"
                      ? colors.primaryOrange
                      : colors.white,
                }}
              >
                <div
                  style={{
                    marginBottom: branchDisplay === "branches" ? 0 : 0,
                    fontWeight: branchDisplay === "branches" ? "bold" : "bold",
                    color:
                      branchDisplay === "branches" ? colors.white : "#00000080",
                    transition: "all 0.3s",
                  }}
                >
                  BRANCHES
                </div>
              </div>
            </div>
            {/* list display */}
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                overflowY: "scroll",
                overflowX: "hidden",
                scrollbarWidth: "none",
                position: "relative",
              }}
            >
              {branchDisplay === "profile" ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      position: "relative",
                      marginTop: 50,
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        height: 150,
                        minWidth: 150,
                        maxWidth: 150,
                        // borderStyle: "solid",
                        borderRadius: 8,
                        marginBottom: 5,
                        marginTop: 5,
                        backgroundColor: colors.white,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        //   position: "absolute",
                        //   top: -200,
                      }}
                    >
                      Image display
                    </div>
                    <div style={{ width: 40 }} />
                    <ImageUploadAWS
                      onChange={(e) => handleFileChangeDriverLiscense(e)}
                      labelTitle={"UPLOAD COMPANY LOGO"}
                      mini={true}
                      errorDisplay={imageError}
                      width={"100%"}
                      size={"90%"}
                      height={30}
                    />
                  </div>
                  <TextInputField
                    width={"80%"}
                    size={"83%"}
                    labelTitle={"ORGNAISATION NAME"}
                    mini={true}
                    value={orgName}
                    onChange={(e) => setOrgName(e.target.value)}
                  />
                  <TextInputField
                    width={"80%"}
                    size={"83%"}
                    labelTitle={"Organisation Id"}
                    mini={true}
                    value={orgId}
                    onChange={(e) => setOrgId(e.target.value)}
                  />

                  <TextInputField
                    width={"80%"}
                    size={"83%"}
                    labelTitle={"Organisation email"}
                    mini={true}
                    value={orgEmail}
                    onChange={(e) => setOrgEmail(e.target.value)}
                  />
                  <TextInputField
                    width={"80%"}
                    size={"83%"}
                    labelTitle={"CONTACT INFO"}
                    mini={true}
                    value={orgEmail}
                    onChange={(e) => setOrgEmail(e.target.value)}
                  />
                  <TextInputField
                    width={"80%"}
                    size={"83%"}
                    labelTitle={"CIPRO Registration"}
                    mini={true}
                    value={orgEmail}
                    onChange={(e) => setOrgEmail(e.target.value)}
                  />
                  <TextInputField
                    width={"80%"}
                    size={"83%"}
                    labelTitle={"Address"}
                    mini={true}
                    value={orgEmail}
                    onChange={(e) => setOrgEmail(e.target.value)}
                  />
                  <div style={{ padding: 200 }} />
                </>
              ) : null}
              {branchDisplay === "branches" ? (
                <>
                  <div
                    style={{
                      position: "absolute",
                      bottom: 270,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      //   zIndex: ,
                    }}
                  >
                    <BaseButtons
                      label={"+ NEW BRANCH"}
                      borderRadius={8}
                      backgroundColor={colors.secondaryOrange}
                      width={"90%"}
                      height={50}
                    />
                  </div>
                  <div
                    style={{
                      flex: 1,
                      //   borderStyle: "solid",
                      width: "95%",
                      marginTop: 35,
                      borderRadius: 20,
                      marginBottom: 10,
                      //   backgroundColor: colors.white,
                      overflowY: "scroll",
                      overflowX: "hidden",
                      scrollbarWidth: "none",
                      borderColor: colors.white,
                    }}
                  >
                    <BranchCard branchName={"TEST"} />
                    <BranchCard branchName={"TEST"} />
                    <BranchCard branchName={"TEST"} />
                    <BranchCard branchName={"TEST"} />
                    <BranchCard branchName={"TEST"} />
                    <BranchCard branchName={"TEST"} />
                    <div style={{ padding: 200 }} />
                  </div>
                </>
              ) : null}
            </div>
          </div>
        )
      ) : (
        <div
          style={{
            height: "100%",
            maxHeight: 900,
            minHeight: 450,
            width: width > 899 ? "94%" : "100%",
            minWidth: width > 899 ? 500 : null,
            maxWidth: 1500,
            backgroundColor: colors.secondaryGrey,
            marginTop: width > 899 ? 0 : 20,
            borderRadius: 20,
            marginLeft: width > 899 ? 5 : 0,
            WebkitBoxShadow:
              width > 899
                ? "-2px 20px 40px -10px #000000"
                : "0px 0px 0px 0px #000000",
            borderStyle: width > 899 ? "solid" : "none",
            borderWidth: 4,
            borderColor: colors.white,
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: width > 899 ? "hidden" : "scroll",
            overflowX: "hidden",
            position: "relative",
            flexDirection: width > 899 ? "row" : "column",
            scrollbarWidth: "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              right: 10,
              top: 10,
              display: "flex",
            }}
          >
            <BaseButtons
              label={"IS ADMIN"}
              borderRadius={8}
              backgroundColor={colors.primaryOrange}
              width={120}
              onClick={() => setIsMainAdmin(true)}
            />
            <div style={{ width: 20 }} />
            <BaseButtons
              label={"UPDATE"}
              borderRadius={8}
              backgroundColor={colors.primaryOrange}
              width={120}
            />
          </div>
          <div
            style={{
              position: "absolute",
              left: width > 899 ? 20 : 10,
              top: 10,
            }}
          >
            <div
              style={{ fontSize: width > 899 ? 34 : 20, fontWeight: "bold" }}
            >
              BRANCH NAME
            </div>
          </div>
          <div
            style={{
              flex: 0.5,
              height: "99%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              marginBottom: width > 899 ? null : 20,
            }}
          >
            <div style={{ height: width > 899 ? null : 50 }} />

            <TextInputField
              width={"80%"}
              size={width > 899 ? 320 : "90%"}
              labelTitle={"Branch name"}
              mini={true}
              value={orgName}
              onChange={(e) => setOrgName(e.target.value)}
            />

            <TextInputField
              width={"80%"}
              size={width > 899 ? 320 : "90%"}
              labelTitle={"Organisation Id"}
              mini={true}
              value={orgId}
              onChange={(e) => setOrgId(e.target.value)}
            />

            <TextInputField
              width={"80%"}
              size={width > 899 ? 320 : "90%"}
              labelTitle={"Organisation email"}
              mini={true}
              value={orgEmail}
              onChange={(e) => setOrgEmail(e.target.value)}
            />
            <TextInputField
              width={"80%"}
              size={width > 899 ? 320 : "90%"}
              labelTitle={"CIPRO Registration"}
              mini={true}
              value={orgEmail}
              onChange={(e) => setOrgEmail(e.target.value)}
            />
            <TextInputField
              width={"80%"}
              size={width > 899 ? 320 : "90%"}
              labelTitle={"Address"}
              mini={true}
              value={orgEmail}
              onChange={(e) => setOrgEmail(e.target.value)}
            />
            <div style={{ height: 20 }} />
            <BaseButtons
              label={"ADMIN USER"}
              backgroundColor={colors.orangeDark}
              width={width > 899 ? 320 : "90%"}
              borderRadius={8}
            />
          </div>
          <div
            style={{
              flex: 0.5,
              height: "99%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <div style={{ height: 75 }} /> */}
            <div
              style={{
                height: 280,
                width: 280,
                // borderStyle: "solid",
                borderRadius: 8,
                marginBottom: 5,
                marginTop: 5,
                backgroundColor: colors.white,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Image display
            </div>
            <ImageUploadAWS
              onChange={(e) => handleFileChangeDriverLiscense(e)}
              labelTitle={"UPLOAD COMPANY LOGO"}
              mini={true}
              errorDisplay={imageError}
              width={"100%"}
              size={280}
              height={30}
            />{" "}
            <div style={{ height: 20 }} />
            <BaseButtons
              label={"BRANCH MANAGER"}
              backgroundColor={colors.orangeDark}
              width={310}
              borderRadius={8}
            />
          </div>
          {width > 899 ? null : <div style={{ padding: 200 }} />}
        </div>
      )}
    </div>
  );
};

export default ManagerDisplay;
